(function () {
  var TC_ATTRIBUTE = 'Fatura T.C. Kimlik No';
  var THRESHOLD_CENTS = 1000000;
  var FIELD_ID = 'kartolog-tc-kimlik-no';
  var BLOCK_CLASS = 'kartolog-checkout-requirements';
  var isSaving = false;

  function normalizeTc(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 11);
  }

  function isValidTc(value) {
    return /^[1-9]\d{10}$/.test(normalizeTc(value));
  }

  function isVisible(element) {
    return Boolean(element && (element.offsetParent !== null || element.getClientRects().length));
  }

  function getCheckoutTargets() {
    return Array.from(
      document.querySelectorAll(
        'button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], .cart__checkout-button'
      )
    ).filter(isVisible);
  }

  function getTcFields() {
    return Array.from(document.querySelectorAll('input[data-kartolog-tc-input]'));
  }

  function getActiveTcField() {
    var fields = getTcFields();
    return (
      fields.find(function (field) {
        return isVisible(field) && normalizeTc(field.value).length;
      }) ||
      fields.find(function (field) {
        return isVisible(field);
      }) ||
      fields[0] ||
      null
    );
  }

  function getFieldValue() {
    var field = getActiveTcField();
    return normalizeTc(field && field.value);
  }

  function syncTcFields(value) {
    var normalized = normalizeTc(value);
    getTcFields().forEach(function (field) {
      if (field.value !== normalized) field.value = normalized;
    });
  }

  async function getCart() {
    var response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('Sepet bilgisi okunamadı.');
    return response.json();
  }

  async function saveTcToCart(tc) {
    var attributes = {};
    attributes[TC_ATTRIBUTE] = tc;

    var response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    });
    if (!response.ok) throw new Error('T.C. kimlik no siparişe eklenemedi.');
    return response.json();
  }

  function buildRequirementsBlock(cart) {
    var block = document.createElement('div');
    block.className = BLOCK_CLASS;
    block.innerHTML =
      '<div class="' +
      BLOCK_CLASS +
      '__address">' +
      '<strong>Adres kontrolü</strong>' +
      '<p>Ödeme ekranında il, ilçe, mahalle, cadde/sokak, bina ve daire bilgilerini eksiksiz gir. Eksik adres kargoyu geciktirir.</p>' +
      '</div>' +
      '<div class="' +
      BLOCK_CLASS +
      '__tc" data-kartolog-tc-wrap hidden>' +
      '<label for="' +
      FIELD_ID +
      '">T.C. Kimlik No</label>' +
      '<input id="' +
      FIELD_ID +
      '" data-kartolog-tc-input name="attributes[' +
      TC_ATTRIBUTE +
      ']" inputmode="numeric" autocomplete="off" maxlength="11" placeholder="11 haneli T.C. kimlik no">' +
      '<p>10.000 TL üzeri alışverişlerde fatura için gereklidir. Sadece sipariş bilgisine eklenir.</p>' +
      '<span class="' +
      BLOCK_CLASS +
      '__error" data-kartolog-tc-error hidden>11 haneli T.C. kimlik no girmen gerekiyor.</span>' +
      '</div>';

    var input = block.querySelector('input');
    input.value = '';
    input.addEventListener('input', function () {
      syncTcFields(input.value);
      setError(false);
    });

    return block;
  }

  function setError(visible, message) {
    document.querySelectorAll('[data-kartolog-tc-error]').forEach(function (item) {
      item.textContent = message || '11 haneli T.C. kimlik no girmen gerekiyor.';
      item.hidden = !visible;
    });
  }

  function setRequiredState(required) {
    document.querySelectorAll('[data-kartolog-tc-wrap]').forEach(function (wrap) {
      wrap.hidden = !required;
      var input = wrap.querySelector('input');
      if (input) input.required = required;
    });
  }

  function injectBlockNearCheckout(cart) {
    getCheckoutTargets().forEach(function (button) {
      var container =
        button.closest('.cart__ctas') ||
        button.closest('.cart-drawer__footer') ||
        button.closest('.cart__footer') ||
        button.parentElement;
      if (!container || container.querySelector('.' + BLOCK_CLASS)) return;
      container.insertBefore(buildRequirementsBlock(cart), container.firstChild);
    });
  }

  async function refresh() {
    try {
      var cart = await getCart();
      injectBlockNearCheckout(cart);
      setRequiredState(cart.total_price >= THRESHOLD_CENTS);
    } catch (error) {
      console.warn('[Kartolog] Checkout requirements could not refresh.', error);
    }
  }

  function isCheckoutEvent(event) {
    var target = event.target;
    var button =
      target &&
      target.closest &&
      target.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button');
    var form = target && target.closest && target.closest('form[action="/cart"], form[action^="/cart"]');
    return button || (event.type === 'submit' && form && event.submitter && event.submitter.name === 'checkout');
  }

  async function handleCheckout(event) {
    if (!isCheckoutEvent(event) || isSaving) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var cart;
    try {
      cart = await getCart();
    } catch (error) {
      window.location.href = '/checkout';
      return;
    }

    if (cart.total_price < THRESHOLD_CENTS) {
      window.location.href = '/checkout';
      return;
    }

    var tc = getFieldValue();
    if (!isValidTc(tc)) {
      setError(true);
      var field = getActiveTcField();
      if (field) field.focus();
      return;
    }

    isSaving = true;
    try {
      await saveTcToCart(tc);
      window.location.href = '/checkout';
    } catch (error) {
      isSaving = false;
      setError(true, error.message || 'T.C. kimlik no siparişe eklenemedi.');
    }
  }

  document.addEventListener('click', handleCheckout, true);
  document.addEventListener('submit', handleCheckout, true);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  setTimeout(refresh, 900);

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._kartologTimer);
    observer._kartologTimer = window.setTimeout(refresh, 200);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
